export class ValidationError extends Error {
  silent: boolean;

  constructor(
    message: string,
    options = {
      silent: false,
    },
  ) {
    super(message);

    this.name = 'ValidationError';
    this.silent = options.silent;
  }
}
